import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import ReCAPTCHA from 'react-google-recaptcha';
import { Collapse } from '@material-ui/core';
import axios from 'axios';
import Box from '../Styled/Box';
import Alert from '../Alerts/Alert';

const Recaptcha = ({
  setIsAllowed,
}) => {
  const [open, setOpen] = React.useState(false);
  const [errorMsg, setErrorMsg] = React.useState('');
  const reCaptchaRef = useRef();

  const onErrored = () => {
    setErrorMsg('Um erro ocorreu. Tente novamente mais tarde!');
    setOpen(true);
    setIsAllowed(false);
  };

  const onChange = async (token) => {
    const formData = new URLSearchParams();
    formData.append('response_token', token);
    const headers = { 'Content-Type': 'application/x-www-form-urlencoded' };

    try {
      const response = await axios.post(process.env.REACT_APP_RECAPTCHA_CHECKBOX_URL, formData.toString(), { headers });
      if (response.data.success) {
        setIsAllowed(true);
      }
      else {
        reCaptchaRef.current.reset();
        setOpen(true);
        setErrorMsg('ReCAPTCHA inválido. Tente novamente.');
        setIsAllowed(false);
      }
    }
    catch (error) {
      onErrored();
    }
  };

  return (
    <>
      <Box mt={3} display='flex' justifyContent='center'>
        <ReCAPTCHA
          ref={reCaptchaRef}
          sitekey={process.env.REACT_APP_RECAPTCHA_CHECKBOX_KEY}
          onChange={onChange}
          onExpired={() => setIsAllowed(false)}
          onErrored={onErrored}
        />
      </Box>
      <Collapse in={open}>
        <Alert mt={3} variant='danger' closeAlert={() => setOpen(false)}>{errorMsg}</Alert>
      </Collapse>
    </>
  );
};

Recaptcha.propTypes = {
  setIsAllowed: PropTypes.func.isRequired,
};

export default Recaptcha;
